export const UserDialogTranslationsDictionary =
{
    user: "User",
    currentUser: "Current User",
    currentDriver: "Current driver",
    logout: "Logout",
    addDriver: "Add Driver",
    switchTo: "Switch to this user",
    driverSeat: "Switch driver",
    noAccessToVehicle: "No access to vehicle",
    sendFeedback: "Send Feedback"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in UserDialogTranslationsDictionary) {
        r.push(UserDialogTranslationsDictionary[prop]);
    }
    return r;
};

export const UserDialogTranslations = getTranslations();